module.exports = __webpack_public_path__ + "img/1.1d7a55bb.png";